import Core from "@/modules/core/service/Core";

/** The running request for the escalator catalogue, so several views opening an escalator GBU load it only once. */
let escalatorLoading = null;

const state = {
    enums: null,
    escalatorEnums: null,
}

const mutations = {
    updateAuditEnums (state, payload) {
        state.enums  = payload;
    },

    updateAuditEscalatorEnums (state, payload) {
        state.escalatorEnums = payload;
    },
}

const actions = {
    initAuditEnums ( { commit, dispatch }) {
        return Core.method.get("/api/audit/enums").then(data => {
            commit ('updateAuditEnums', data);
            // loaded in the background, the start of LM4 does not wait for it
            dispatch('initAuditEscalatorEnums');
        });
    },

    /**
     * The catalogue of the escalator GBU (HCIT-917). A failure does not stop the start of LM4; an escalator GBU
     * loads it again when it is opened.
     */
    initAuditEscalatorEnums ( { commit }) {
        if (!escalatorLoading) {
            escalatorLoading = Core.method.get("/api/audit/enums?deviceType=ESCALATOR").then(data => {
                commit ('updateAuditEscalatorEnums', data);
            }).catch(error => {
                console.log("escalator audit catalogue not loaded", error);
            }).finally(() => {
                escalatorLoading = null;
            });
        }

        return escalatorLoading;
    },
}

const getters = {
    audit: state => {
        return state.enums;
    },

    auditEscalator: state => {
        return state.escalatorEnums;
    },
}

const auditModule = {
    state,
    mutations,
    actions,
    getters
}

export default auditModule
